import React from "react";
import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";
import ISONumber from "components/formatting/ISONumber";

export interface NumberOptions {
  headerLabels?: Record<string, string>;
}

function numberColumn(options?: NumberOptions): GridColTypeDef {
  const numberColumn: GridColTypeDef = {
    ...baseColumn,
    type: "number",
    align: "right",
    renderCell: (params: GridRenderCellParams) => {
      if (!params.value) return <></>;

      const value = parseFloat(params.value)
      return (
        <Box>
          <ISONumber fitToContainer={false} number={value} />
        </Box>
      );
    }
  };
  if (options?.headerLabels) {
    numberColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return numberColumn;
}

export default numberColumn;